import { render, staticRenderFns } from "./AIimage.vue?vue&type=template&id=52eccda9&scoped=true&"
import script from "./AIimage.vue?vue&type=script&lang=js&"
export * from "./AIimage.vue?vue&type=script&lang=js&"
import style0 from "./AIimage.vue?vue&type=style&index=0&id=52eccda9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52eccda9",
  null
  
)

export default component.exports